"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCommsSessionResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateCommsSessionResult = (0, validation_1.properties)({
    id: (0, validation_1.text)(),
    url: (0, validation_1.text)(),
});
//# sourceMappingURL=CommsSessionResult.js.map